import React from 'react';
import styled from 'styled-components';

const View = styled.div`
    font-size: 12px;
    line-height: 1.75;
    color: #9b9b9b;
`;

const Text = props => {
    return <View className={props.className}>{props.children}</View>;
};

export default Text;



// WEBPACK FOOTER //
// ./src/components/shared/Text.js